import { NgModule, Pipe, PipeTransform } from '@angular/core';

// 찬스톡에 사용 : 오늘 날짜와 비교
@Pipe({name: 'dataCompare'})
export class DataCompare implements PipeTransform {
    transform(time: string): boolean {
        if (typeof time !== 'undefined') {
            const now = new Date();
            const expiredDt = new Date(time);
            return expiredDt >= now ? false : true;
        }
        return true;
    }
}

/**
 * 찬스톡용 날짜 포맷
 */
@Pipe({name: 'transferChancetalk'})
export class TransferChancetalk implements PipeTransform {
    transform(time: string): string {
        const now: any = new Date();
        const createdDt: any = new Date(time);

        const dateGap = now.getTime() - createdDt.getTime();

        if (dateGap === 0) { return '방금'; }

        // const timeGap = new Date(0, 0, 0, 0, 0, 0, now - createdDt);

        const diffDay  = Math.floor(dateGap / (1000 * 60 * 60 * 24)); // 일수
        // let diffHour = timeGap.getHours();         // 시간
        // let diffMin  = timeGap.getMinutes();        // 분
        // let diffSec  = timeGap.getSeconds();        // 초

        let hours = createdDt.getHours();
        let minutes = createdDt.getMinutes();

        if (diffDay === 0) { // 오후 10:30

            const ampm = hours >= 12 ? '오후' : '오전';
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            minutes = minutes < 10 ? '0' + minutes : minutes;
            return ampm + ' ' + hours + ':' + minutes;
        } else {
            return createdDt.getFullYear() + '. ' + (createdDt.getMonth() + 1) + '. ' + createdDt.getDate();
        }
    }
 }


@Pipe({name: 'chancetalkGroupName'})
export class ChancetalkGroupName implements PipeTransform {
    transform(chatter, group): string {
        const participants = {mb_nick: [], mb_id: []};
        for (const value of group) {
            participants.mb_nick.push(value.mb_nick);
            participants.mb_id.push(value.mb_id);
        }
        return participants.mb_nick.join(',');
    }
 }

@NgModule({
    declarations: [ DataCompare, TransferChancetalk, ChancetalkGroupName ],
    exports: [ DataCompare, TransferChancetalk, ChancetalkGroupName ],
})
export class SharedPipeChatModule { }
